import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cheeta-logo-white.png'


const _withScopeId = n => (_pushScopeId("data-v-34821042"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blueprint" }
const _hoisted_2 = { class: "blueprint-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "ARTWORK DETAILS", -1))
const _hoisted_6 = { class: "body-information" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Order Number", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Order Date", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Product Type", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Quantity", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Template", -1))
const _hoisted_12 = { class: "body-colors" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "color-header" }, "Product colors:", -1))
const _hoisted_14 = { class: "featured-colors" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "button hidden" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "body-image" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "sizes-details"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label" }, "SIZES", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Size"),
  /*#__PURE__*/_createElementVNode("th", null, "Quantity")
], -1))
const _hoisted_24 = {
  key: 1,
  class: "product-data"
}
const _hoisted_25 = {
  key: 0,
  class: "logo-list"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label" }, "LOGOTYPES", -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "position" }
const _hoisted_29 = { class: "image" }
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_32 = {
  key: 1,
  class: "hor-line"
}
const _hoisted_33 = {
  key: 2,
  class: "players-details"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label" }, "PLAYERS DETAILS", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Number"),
  /*#__PURE__*/_createElementVNode("th", null, "Size"),
  /*#__PURE__*/_createElementVNode("th", null, "Quantity")
], -1))
const _hoisted_36 = {
  key: 2,
  class: "body-additional-info"
}
const _hoisted_37 = {
  key: 0,
  class: "logo-block"
}
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 1,
  class: "text-block"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Front text: ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Back text: ", -1))
const _hoisted_42 = { class: "block-text-color" }
const _hoisted_43 = {
  key: 2,
  class: "addons-block"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-header" }, "Addons:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "disclaimer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "vl" }),
  /*#__PURE__*/_createTextVNode(" Some logos may require adjustments to improve the quality to get the best product! One of our Account Managers will be in contact with you to discuss the options. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogoClick && _ctx.handleLogoClick(...args)))
      }, _hoisted_4),
      _hoisted_5
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedItems, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "blueprint-body",
        key: index
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                _hoisted_7,
                _createElementVNode("td", null, _toDisplayString(_ctx.orderMeta.id), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_8,
                _createElementVNode("td", null, _toDisplayString(_ctx.orderMeta.date), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_9,
                _createElementVNode("td", null, _toDisplayString(item.alias), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", null, _toDisplayString(item.quantity), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", null, _toDisplayString(item.product), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.details.colors, (color, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "color-details"
                }, [
                  color
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", {
                          class: "color-block",
                          style: _normalizeStyle(`background-color: ${color.value}`)
                        }, null, 4),
                        _createElementVNode("div", null, _toDisplayString(color.name), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.downloadImages(item))
            }, "DOWNLOAD ASSETS", 8, _hoisted_17)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("img", {
            src: item.imageFront,
            alt: "Front side of the product"
          }, null, 8, _hoisted_19),
          _createElementVNode("img", {
            src: item.imageBack,
            alt: "Back side of the product"
          }, null, 8, _hoisted_20)
        ]),
        (item.details.sizes.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", null, [
                _createElementVNode("table", null, [
                  _hoisted_23,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.details.sizes, (size) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: size.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(size.size.name), 1),
                      _createElementVNode("td", null, _toDisplayString(size.quantity), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (
          item.logos !== null ||
          (item.details.playersDetails && item.details.playersDetails.length)
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              (item.logos !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.logos, (value, name) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "list-element",
                        key: value?.image
                      }, [
                        value
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("span", _hoisted_28, _toDisplayString(name) + ":", 1),
                              _createElementVNode("span", _hoisted_29, [
                                _createElementVNode("img", {
                                  src: value.image,
                                  alt: ""
                                }, null, 8, _hoisted_30)
                              ]),
                              _hoisted_31
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (item.logos !== null)
                ? (_openBlock(), _createElementBlock("hr", _hoisted_32))
                : _createCommentVNode("", true),
              (item.details.playersDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("div", null, [
                      _createElementVNode("table", null, [
                        _hoisted_35,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.details.playersDetails, (player) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: player.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(player.name), 1),
                            _createElementVNode("td", null, _toDisplayString(player.number), 1),
                            _createElementVNode("td", null, _toDisplayString(player.size ? player.size.name : "N/A"), 1),
                            _createElementVNode("td", null, _toDisplayString(player.quantity), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_36, [
              (item.logo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("img", {
                      src: item.logo.image,
                      alt: ""
                    }, null, 8, _hoisted_38)
                  ]))
                : _createCommentVNode("", true),
              (item.details.text)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", {
                      class: "block-product-text",
                      style: _normalizeStyle(`font-family: ${item.details.text.font};`)
                    }, [
                      _hoisted_40,
                      _createTextVNode(" " + _toDisplayString(item.details.text.message), 1)
                    ], 4),
                    (item.details.text.type === 'front&back')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "block-product-text",
                          style: _normalizeStyle(`font-family: ${item.details.text.font};`)
                        }, [
                          _hoisted_41,
                          _createTextVNode(" " + _toDisplayString(item.details.text.back_side_text.message), 1)
                        ], 4))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, "Font: " + _toDisplayString(item.details.text.font), 1),
                    _createElementVNode("div", _hoisted_42, [
                      _createTextVNode(" Color: " + _toDisplayString(item.details.text.color.name) + " ", 1),
                      _createElementVNode("div", {
                        class: "color-block",
                        style: _normalizeStyle(`background-color: ${item.details.text.color.value}; margin-left: 5px`)
                      }, null, 4)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.addons.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.addons, (addon) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: addon.id
                        }, _toDisplayString(addon.name), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])),
        _hoisted_45
      ]))
    }), 128))
  ]))
}